import ls from 'localstorage-slim';
import { createButton, createDiv } from '../../../libs/HTML/HTMLElementCreator';
import type { AppState } from '../../state/AppState';
import { displayDebugAlert } from '../debugAlert';

const tempSaveKey = 'LOCKED_SAVE_STATE_KEY';

const statesBankKey = 'LOCKED_SAVE_STATES_BANK';

type SaveStateBank = Record<string, AppState>;

export function debugApplyLockedSaveState(): void {
  const saveStateKey: string | null = ls.get(tempSaveKey);
  if (!saveStateKey) return;

  const bank: SaveStateBank = ls.get(statesBankKey) ?? {};

  if (!bank[saveStateKey]) return;

  displayDebugAlert(`Save state lock: ${saveStateKey}`);
  ls.set(`${APP_NAME}State`, bank[saveStateKey]);
}

export function saveCurrentSaveStateAsLocked(): void {
  // eslint-disable-next-line no-alert
  const key = prompt();
  if (!key) return;

  const currentState: AppState | null = ls.get(`${APP_NAME}State`);
  if (!currentState) return;

  const bank: SaveStateBank = ls.get(statesBankKey) ?? {};
  bank[key] = currentState;

  ls.set(statesBankKey, bank);
}

export function pickLockedSaveState(): void {
  const div = createDiv({
    parentElement: document.body,
    style: {
      position: 'fixed',
      right: '30%',
      top: '30%',
      width: '40%',
      height: '40%',
      backgroundColor: 'grey',
    },
  });

  Object.keys(ls.get(statesBankKey) ?? {}).forEach((key) => {
    const buttonDiv = createDiv({
      style: {
        display: 'inline-block',
      },
      parentElement: div
    });
    createButton({
      labelText: key,
      onClick(): void {
        ls.set(tempSaveKey, key);
      },
      parentElement: buttonDiv,
    });
    createButton({
      labelText: 'DEL',
      style: {
        color: 'red',
      },
      onClick(): void {
        ls.remove(tempSaveKey);
      },
      parentElement: buttonDiv,
    });
  });

  createButton({
    labelText: 'CLOSE',
    onClick: () => {
      div.remove();
    },
    parentElement: div,
  });
}

export function clearLockedSaveState(): void {
  ls.remove(tempSaveKey);
}
